/**
 * GT Collection — load more products via Section Rendering API.
 * Preserves active filters/sort from window.location.search; facets.js resets grid on filter change.
 */
(function () {
  'use strict';

  /**
   * @param {HTMLButtonElement} button
   */
  function handleLoadMore(button) {
    var nextPage = button.getAttribute('data-next-page');
    var sectionId = button.getAttribute('data-section-id');
    if (!nextPage || !sectionId || button.disabled) return;

    var root = button.closest('.gt-collection-product-grid');
    var productGrid = root && root.querySelector('#product-grid');
    if (!productGrid) return;

    var spinner = button.querySelector('.loading__spinner');

    button.disabled = true;
    button.classList.add('loading');
    button.setAttribute('aria-busy', 'true');
    if (spinner) spinner.classList.remove('hidden');

    var fetchUrl = new URL(window.location.pathname, window.location.origin);
    var params = new URLSearchParams(window.location.search);
    params.delete('section_id');
    params.set('page', nextPage);
    params.set('section_id', sectionId);

    fetch(fetchUrl.pathname + '?' + params.toString())
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to load more products');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        if (!newGrid) throw new Error('Could not find product grid in response');

        newGrid.querySelectorAll('.grid__item').forEach(function (item) {
          item.querySelectorAll('.scroll-trigger').forEach(function (el) {
            el.classList.add('scroll-trigger--cancel');
          });
          productGrid.appendChild(item);
        });

        var newButton = doc.querySelector('[data-gt-collection-load-more]');
        var next = newButton && newButton.getAttribute('data-next-page');
        var pagination = button.closest('[data-gt-collection-pagination]');

        if (next && pagination) {
          button.setAttribute('data-next-page', next);
          button.disabled = false;
          button.classList.remove('loading');
          button.removeAttribute('aria-busy');
          if (spinner) spinner.classList.add('hidden');
        } else if (pagination) {
          pagination.remove();
        }
      })
      .catch(function (err) {
        console.error(err);
        button.disabled = false;
        button.classList.remove('loading');
        button.removeAttribute('aria-busy');
        if (spinner) spinner.classList.add('hidden');
      });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var button = target.closest('[data-gt-collection-load-more]');
    if (!(button instanceof HTMLButtonElement)) return;
    event.preventDefault();
    handleLoadMore(button);
  });
})();
